<template>
  <RouterView />
</template>

<script>
import { provide, ref, onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import cn from '@/locales/cn.json'

export default {
  name: 'App',
  setup() {
    const { t } = useI18n({
      messages: {
        en,
        cn,
      },
    })

    provide('t', t)

    // 前端的 process.env.NODE_ENV：
    // yarn build 時會被設成 production
    // yarn serve 時會被設成 development
    // 吃不到後端的 process.env.NODE_ENV，因此需要另外 fetch 後端的 process.env.NODE_ENV 來更新成 stage

    // const isDev = false
    const isDev = process.env.NODE_ENV === 'development'
    const nodeEnv = ref('development')

    onBeforeMount(async () => {
      if (isDev) return

      try {
        const response = await fetch('/env')
        const env = await response.text()
        nodeEnv.value = env
        console.log('nodeEnv', nodeEnv.value)
      } catch (error) {
        console.error('Failed to fetch NODE_ENV from server:', error)
      }
    })

    provide('nodeEnv', nodeEnv)
    provide('isDev', isDev)

    return {
      t,
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Mukta&family=Open+Sans&family=Lato&family=Roboto');

body {
  overflow-x: hidden;
  overflow-y: auto;
  font-family: Mukta, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'!important;
  margin: 0;
}

code {
  font-size: 12px!important;
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace!important;
  background: #eee;
  padding: 0 4px;
  border-radius: 2px;
  border: 1px solid rgba(38, 50, 56, 0.1);
}

.ant-table-thead > tr > th {
  overflow-wrap: normal!important;
}
</style>
